@if (apiLoaded | async) {
  <google-map
    [height]="height"
    width="100%"
    [zoom]="zoom"
    [center]="center"
    [options]="options"
    (mapInitialized)="onMapReady($event)"
    >
    @for (marker of markers; track marker) {
      <map-marker
        [position]="marker.position"
        [options]="marker.options"
        (mapClick)="onMarkerClicked(marker)"
        #mapMarker1
      ></map-marker>
    }
    @for (marker of markersSelected; track marker) {
      <map-marker
        [position]="marker.position"
        [options]="marker.options"
        (mapClick)="onMarkerClicked(marker)"
        #mapMarker2
      ></map-marker>
    }
  </google-map>
}
